//@flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

import FaqItem from './components/FaqItem';

import styles from './LoyaltyModulesWrapper.scss';

const TpnFaq = () => (
    <div className={styles.bottomSection}>
        <BarHeader
            dataTn="tpn-faq-header"
            size="xLarge"
            title={
                <FormattedMessage
                    id="rewards.RewardsWrapper.faqHeader"
                    defaultMessage="Frequently Asked Questions"
                />
            }
        />
        <div>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.enrollmentQuestion"
                        defaultMessage="What if I'm already enrolled in a 1stdibs loyalty program?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.enrollmentAnswer"
                    defaultMessage="We are expanding our existing loyalty program, and if you’ve enrolled in a 1stdibs loyalty program before the launch on May 1, 2018, your membership will automatically carry over to the expanded program. You do not need to take any additional action."
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.trustedPartnerQuestion"
                        defaultMessage="What if my firm already has Trusted Partner status?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.trustedPartnerAnswer"
                    defaultMessage="Your firm’s Trusted Partner status will carry over into Trade Rewards. We’ve added additional benefits to the program, so the more points your firm earns, the more rewards you will receive. If you would like to discuss your Trusted Partner status, please reach out to your account executive or the Trade Concierge at {emailLink}."
                    values={{
                        emailLink: <a href="mailto:trade@1stdibs.com">trade@1stdibs.com</a>,
                    }}
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.portfolioQuesion"
                        defaultMessage="How do I create my firm’s portfolio?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.portfolioAnswer"
                    defaultMessage="1stdibs proudly displays the portfolios of firms that reach Silver, Gold and Platinum Trusted Partner tiers on our site. To create your firm’s portfolio, please reach out to {emailLink}."
                    values={{
                        emailLink: (
                            <a href="mailto:tradeprofiles@1stdibs.com">tradeprofiles@1stdibs.com</a>
                        ),
                    }}
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.earnQuesion"
                        defaultMessage="How does my firm earn rewards?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.earnAnswer"
                    defaultMessage="After you enroll in Trade Rewards, your firm will earn points with every purchase. $1 spent equals 1 point. You will only earn points for merchandise; shipping and taxes are not included. Remember, purchases made by all enrolled colleagues of your firm will count toward your firm’s collective rewards."
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.receiveQuesion"
                        defaultMessage="How do I receive cash rewards?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.receiveAnswer"
                    defaultMessage="Your firm will automatically receive cash back every time it earns 5,000 points on 1stdibs.com. US firms will be mailed an American Express gift card to the address provided during enrollment. International firms will receive a Visa gift card."
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.howLongToReceiveQuesion"
                        defaultMessage="How long does it take to receive my reward?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.howLongToReceiveAnswer"
                    defaultMessage="You can expect to receive your cash reward within 4 weeks. US firms will be mailed an American Express gift card to the address provided during enrollment. International firms will receive a Visa gift card."
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.howLongStatusQuesion"
                        defaultMessage="How long does my Gold, Silver or Platinum Trusted Partner status last?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.howLongStatusAnswer"
                    defaultMessage="Your status will last at least one calendar year and is based on earned points from the prior calendar year as well as the current year."
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.higherAmountQuesion"
                        defaultMessage="If my firm's cash back reward increases, when does the higher amount take effect?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.higherAmountAnswer"
                    defaultMessage="Once you start earning increased cash back rewards, the higher amount will be effective immediately. As an additional reward, you’ll receive your new, increased cash-back rate on all previous spend from the current calendar year."
                />
            </FaqItem>
            <FaqItem
                questionCopy={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.moreQuestions"
                        defaultMessage="Have more questions?"
                    />
                }
            >
                <FormattedMessage
                    id="rewards.RewardsWrapper.moreQuestionsAnswer[0]"
                    defaultMessage="Contact our dedicated team members of the Trade Rewards Loyalty program {enrollmentLink}"
                    values={{
                        enrollmentLink: (
                            <a href="/trade/loyalty/enrollment/">
                                <FormattedMessage
                                    id="rewards.RewardsWrapper.moreQuestionsAnswer[1]"
                                    defaultMessage="here."
                                />
                            </a>
                        ),
                    }}
                />
            </FaqItem>
        </div>
    </div>
);

export default TpnFaq;
